import replaceVariables from "@workspace/cms-phrases/src/phrase/replaceVariables";

type GamesCountTemplates = {
  gamesCountOne: string;
  gamesCountMany: string;
};

const getGamesCountLabel = (
  count: number,
  { gamesCountOne, gamesCountMany }: GamesCountTemplates,
) => replaceVariables(count === 1 ? gamesCountOne : gamesCountMany, { count });

export default getGamesCountLabel;
